import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Check, X } from "lucide-react";

const KIND_LABEL = { member: "Member", fee_payment: "Fee payment", ledger: "Ledger entry", camp: "Camp" };

export default function DeletionRequests({ requests, onChanged }) {
  const decide = async (id, action) => {
    try {
      await api.put(`/admin/deletion-requests/${id}`, { action });
      toast.success(action === "approve" ? "Deleted as requested" : "Deletion request rejected");
      onChanged();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <Card className="card-shadow-soft" data-testid="deletion-requests">
      <CardHeader>
        <CardTitle className="text-lg">Deletion requests awaiting approval <span data-testid="deletion-pending-count" className="text-muted-foreground">({requests.length})</span></CardTitle>
      </CardHeader>
      <CardContent>
        {requests.length === 0 && <p className="text-sm text-muted-foreground" data-testid="no-deletion-requests">Nothing waiting for approval.</p>}
        {requests.map((r) => (
          <div key={r.id} data-testid={`deletion-row-${r.id}`} className="flex flex-col sm:flex-row sm:items-center gap-3 py-3 border-b border-border last:border-0">
            <div className="flex-1 min-w-0">
              <div className="font-semibold truncate"><span className="scout-tag bg-secondary text-foreground mr-2">{KIND_LABEL[r.kind] || r.kind}</span>{r.label}</div>
              <div className="text-xs text-muted-foreground">Requested by {r.requested_by_name} · {r.created_at.slice(0, 16).replace("T", " ")}</div>
            </div>
            <div className="flex gap-2">
              <Button size="sm" variant="destructive" data-testid={`deletion-approve-${r.id}`} onClick={() => decide(r.id, "approve")}><Check className="w-4 h-4 mr-1" /> Approve delete</Button>
              <Button size="sm" variant="outline" data-testid={`deletion-reject-${r.id}`} onClick={() => decide(r.id, "reject")}><X className="w-4 h-4 mr-1" /> Keep</Button>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
